import { locations } from '@contentful/app-sdk'
import { useSDK } from '@contentful/react-apps-toolkit'
import { useMemo } from 'react'
import Field from './locations/Field'

const ComponentLocationSettings = {
  [locations.LOCATION_ENTRY_FIELD]: Field
}

const App = () => {
  const sdk = useSDK()

  const Component = useMemo(() => {
    for (const [location, component] of Object.entries(ComponentLocationSettings)) {
      if (sdk.location.is(location)) {
        return component
      }
    }
  }, [sdk.location])

  return Component ? <Component /> : <div>Unsupported Contentful location.</div>
}

export default App
